
import { useCallback } from 'react';
import { UserProfile } from '../types';
import { AnalyticsService } from '../services/AnalyticsService';

/**
 * Hook to provide context-aware analytics tracking.
 * Automatically injects organization context into events.
 */
export const useAnalytics = (userProfile: UserProfile | null) => {
    
    const track = useCallback((eventName: string, properties: any = {}) => {
        if (!userProfile) return;

        // Automatically inject organization ID into all events
        const enrichedProperties = {
            ...properties,
            orgId: userProfile.orgId,
            userRole: userProfile.teams?.[0]?.role || 'engineer' // Basic role context
        };

        AnalyticsService.track(eventName, enrichedProperties);
    }, [userProfile]);

    const identify = useCallback((userId: string, traits: any = {}) => {
        AnalyticsService.identify(userId, traits);
    }, []);

    const page = useCallback((pageName?: string, properties: any = {}) => {
        if (!userProfile) return;
        AnalyticsService.page(pageName, {
            ...properties,
            orgId: userProfile.orgId
        });
    }, [userProfile]);

    return { track, identify, page };
};
